import './Services.scss';

import { motion } from "framer-motion"

import systemEngineering from "./icons/01-icon-system-engineering.svg";
import webDev from "./icons/02-icon-web-development.svg";
import database from "./icons/03-icon-database-design.svg";
import universityTeaching from "./icons/04-icon-university-teaching.svg";
import videoTutorial from "./icons/05-icon-video-tutorials.svg";
import android from "./icons/06-icon-android-development.svg";
import ai from "./icons/07-icon-ai-consulting.svg";
import lecturing from "./icons/08-icon-guest-lecturing.svg";

import { Counters, ICounterDataItem } from '../Counters/Counters';

interface IService {
    icon: string,
    title: string,
    text: string
}

export function Services() {
    const services: IService[] = [
        {
            icon: systemEngineering,
            title: "System Engineering",
            text: "I can design and implement every part of a completely customised solution based on the company's requirements to provide a complete digital transformation.",
        },
        {
            icon: webDev,
            title: "Web Development",
            text: "With almost a decade and a half of working in JavaScript/TypeScript and PHP, I can create any web application (both back-end and front-end) in nearly every framework."
        },
        {
            icon: database,
            title: "Database Design",
            text: "Analysing, modelling, and implementing databases of various sizes, complexities, and types (relational, document-oriented and graph) is my everyday routine."
        },
        {
            icon: universityTeaching,
            title: "University Teaching",
            text: "I have worked in higher education since 2012 as a teaching assistant and an assistant professor. I have over 4000 hours in class and have taught over 1000 students."
        },
        {
            icon: videoTutorial,
            title: "Video Tutorials",
            text: "I have created over 500 free educational tutorial videos in Serbian, published on YouTube so that everyone can get into IT more easily."
        },
        {
            icon: android,
            title: "Android Development",
            text: "I have developed several Android apps and worked as an Android developer in the early years of Android development (2010-2014)."
        },
        {
            icon: ai,
            title: "ML/AI Consulting",
            text: "A significant part of my doctoral studies scientific research concerns application of ML and AI. Need help applying them in your business?"
        },
        {
            icon: lecturing,
            title: "Guest Lecturing",
            text: "As an experienced educator with professional training also outside of academia, I can hold tailored training and lectures at request."
        },
    ];

    const counters: ICounterDataItem[] = [
        { title: "Completed projects", value: 75, },
        { title: "YouTube tutorials", value: 600, },
        { title: "Mentorships", value: 15, },
        { title: "Students taught", value: 1000, },
        { title: "Lecture hours", value: 4000, },
    ];

    return (
        <div className="page-content">
            <div className="page-name" data-title="What I do">What I do</div>
            <div className="service-block-holder mt-3">
                { services.map(service => (
                    <motion.div
                        initial={{
                            y: 50,
                            opacity: 0,
                        }}
                        whileInView={{
                            y: 0,
                            opacity: 1,
                        }}
                        viewport={{ once: true }}
                        whileHover={{
                            scale: 1.2,
                        }}
                        className="service-block" key={ service.title }
                        itemScope itemType="https://schema.org/Service">
                        <div className="service-block-image-holder">
                            <img className="service-block-image" src={ service.icon } alt={ service.title } />
                        </div>
                        <h2 className="service-block-title" itemProp="name">{ service.title }</h2>
                        <div className="service-block-text" itemProp="slogan">{ service.text }</div>
                    </motion.div>
                )) }
            </div>

            <Counters counters={ counters } />
        </div>
    );
}
